import { Navigate } from 'react-router-dom';

import { MLB_PLAY } from '@sorare/core/src/constants/__generated__/routes';

const ComposeTeam = () => {
  return <Navigate to={MLB_PLAY} />;
};

export default ComposeTeam;
